module.exports = __webpack_public_path__ + "static/loveunique.d2104f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clients/loveunique.png
// module id = 247
// module chunks = 35783957827783 269829036549620